import React from 'react';
import { Star } from 'lucide-react';

export const StarRating = ({ rating, interactive = false, onChange = null, size = 20 }) => {
  const stars = [1, 2, 3, 4, 5];

  return (
    <div className="flex gap-1">
      {stars.map((star) => (
        <Star
          key={star}
          className={`${interactive ? 'cursor-pointer' : ''} transition-colors`}
          size={size}
          fill={star <= rating ? '#D4AF37' : 'none'}
          stroke={star <= rating ? '#D4AF37' : '#E5E5E5'}
          onClick={() => interactive && onChange && onChange(star)}
        />
      ))}
    </div>
  );
};
